import axios from 'axios';

const API_BASE_URL = 'https://system.letavy.sk/api';

const letavyApi = axios.create({
  baseURL: API_BASE_URL
});

export const getDielne = async (datumNarodenia = '1.1.2000') => {
  try {
    const response = await letavyApi.get(`/dielne/zoznam/${encodeURIComponent(datumNarodenia)}`);
    return response.data;
  } catch (error) {
    console.error('Chyba pri získavaní dielní:', error);
    throw error;
  }
};

export const createRezervacia = async (dielnaId) => {
  try {
    const response = await letavyApi.get(`/reservation/${dielnaId}`);
    return response.data;
  } catch (error) {
    console.error('Chyba pri vytváraní rezervácie:', error);
    throw error;
  }
};

export const submitRegistracia = async (rezervaciaId, data) => {
  try {
    const response = await letavyApi.post(`/registracia/${rezervaciaId}`, data);
    return response.data;
  } catch (error) {
    console.error('Chyba pri odosielaní registrácie:', error);
    throw error;
  }
};
